import React from 'react'
import PropTypes from 'prop-types'
import { Button } from './ui/button'

/**
 * Shown when `GET /api/user` fails for a reason other than 401 during page
 * load. The session was not rejected, so the login form would be wrong here.
 */
export default function SessionLoadError({ onRetry }) {
  return (
    <main className="flex min-h-screen w-full items-center justify-center bg-background p-6">
      <div role="alert" className="max-w-md space-y-4 text-center">
        <h1 className="text-xl tracking-tight">We could not load your account</h1>
        <p className="text-sm text-muted-foreground">
          This is on our end. Try again, or email help@theresidesk.com if it keeps happening.
        </p>
        <Button type="button" onClick={onRetry}>
          Try again
        </Button>
      </div>
    </main>
  )
}

SessionLoadError.propTypes = {
  onRetry: PropTypes.func.isRequired,
}
